<template>
  <div class="row">
    <div class="col-md-7">
      <div class="card">
        <div class="card-header bg-dark">
          <h3 class="mb-0 text-white">ตั้งค่าบัญชี SCB</h3>
        </div>
        <div class="card-body">
          <base-button type="primary" icon @click="addModalOpen = true">
            เพิ่ม
          </base-button>

          <div
            class="d-flex align-items-center bg-dark p-3 rounded mt-3"
            v-for="(acc, k) in accounts"
            :key="k"
          >
            <div>
              <h3 class="text-white mb-0">
                <i
                  class="fas fa-circle mr-1"
                  :class="{
                    'text-success': acc.enable,
                    'text-danger': !acc.enable,
                  }"
                />
                {{ acc.accountName }}
              </h3>
              <h6 class="text-white mb-0">
                {{ acc.accountNumber }} / ยอดคงเหลือ:
                <template v-if="acc.error != ''">
                  {{ acc.error }}
                </template>
                <template v-else>
                  {{ acc.balance | format }}
                </template>
              </h6>
            </div>
            <div class="ml-auto d-flex flex-wrap">
              <base-button
                type="default"
                size="sm"
                @click="setWithdraw(acc.accountNumber)"
                :disabled="loading"
                v-if="!acc.isWithdrawAccount"
              >
                ตั้งบัญชีถอน
              </base-button>
              <base-button
                type="warning"
                size="sm"
                :disabled="loading"
                @click="toggleSCB(acc.accountNumber)"
              >
                เปิด/ปิด
              </base-button>
              <base-button
                type="primary"
                size="sm"
                :disabled="loading"
                @click="toggleHide(acc.accountNumber)"
                v-if="acc.hide"
              >
                แสดง
              </base-button>
              <base-button
                type="primary"
                size="sm"
                :disabled="loading"
                @click="toggleHide(acc.accountNumber)"
                v-else
              >
                ซ่อน
              </base-button>
              <base-button
                type="secondary"
                size="sm"
                :disabled="loading"
                @click="withdrawToCentral(acc.accountNumber)"
              >
                โอนเข้าบัญชีกลาง
              </base-button>
              <base-button
                type="danger"
                size="sm"
                :disabled="loading"
                @click="deleteSCB(acc.accountNumber)"
              >
                ลบ
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <auto-panel />
    </div>

    <add-modal
      :open="addModalOpen"
      @close="addModalOpen = false"
      @reload="reload"
    />
  </div>
</template>

<script>
import AddModal from "../backend-components/SCB/AddModal";
import AutoPanel from "../backend-components/SCB/AutoPanel";

import { mapGetters } from "vuex";
import SettingService from "../services/setting.service";
import api from "../services";
import Swal from "sweetalert2";

export default {
  components: {
    AddModal,
    AutoPanel,
  },
  data() {
    return {
      addModalOpen: false,

      loading: false,
      accounts: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["hasFeature"]),
  },
  methods: {
    async reload() {
      try {
        const res = await SettingService.getSCBAccounts();
        this.accounts = res.data;
        console.log(this.accounts);
        for (const property in this.accounts) {
          this.getBalance(property);
        }
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      }
    },
    async getBalance(account) {
      try {
        const res = await SettingService.getSCBBalance(account);
        this.accounts[account].balance = res.balance;
        this.accounts[account].error = "";
      } catch ({ message }) {
        this.accounts[account].error = message;
        this.$notify({ type: "danger", message });
      }
    },
    async setWithdraw(accountNo) {
      try {
        this.loading = true;
        const res = await api.post(`/setting/scb/${accountNo}/withdraw`);

        this.$notify({ type: "success", message: res.message });
        this.reload();
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      } finally {
        this.loading = false;
      }
    },
    async toggleSCB(accountNo) {
      try {
        this.loading = true;
        const res = await SettingService.toggleSCB(accountNo);

        this.$notify({ type: "success", message: res.message });
        this.reload();
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      } finally {
        this.loading = false;
      }
    },
    async deleteSCB(accountNo) {
      try {
        this.loading = true;
        const res = await SettingService.deleteSCB(accountNo);

        this.$notify({ type: "success", message: res.message });
        this.reload();
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      } finally {
        this.loading = false;
      }
    },
    async toggleHide(accountNo) {
      try {
        this.loading = true;
        const res = await SettingService.toggleHideSCB(accountNo);

        this.$notify({ type: "success", message: res.message });
        this.reload();
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      } finally {
        this.loading = false;
      }
    },
    async withdrawToCentral(accountNo) {
      try {
        const val = await Swal.fire({
          icon: "info",
          title: `คุณต้องการโอนเงินเข้าบัญชีกลาง?`,
          showCancelButton: true,
        });
        if (!val) return false;

        this.loading = true;
        const res = await api.post(
          `/setting/scb/${accountNo}/withdraw-central`
        );

        this.$notify({ type: "success", message: res.message });
        this.reload();
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.reload();
  },
};
</script>
